<template>
  <Popover v-model:open="isOpen">
    <PopoverTrigger>
      <img :src="avatar" alt="avatar" class="w-5" />
    </PopoverTrigger>
    <PopoverContent class="border-none bg-sidebar" align="end" :alignOffset="-40"> 
      <div class="flex gap-4 ">
        <div class="w-10 h-10 min-w-10 min-h-10 bg-primary rounded-full text-white flex items-center justify-center">
          {{ userInfo?.name.charAt(0) ?? "?" }}
        </div>
        <div class="flex flex-col gap-2">
          <p>{{ userInfo?.name ?? "" }}</p>        
          <p>{{ userInfo?.userAccount ?? "" }}</p>
        </div>
      </div>
      <Separator  />
      <div class="pt-4 flex flex-col">
        <div 
          v-for="item in menuItems" 
          :key="item.id"
          @click="item.handler" 
          class="cursor-pointer hover:bg-lightPurple hover:text-sidebar py-1 px-4 -mx-4 h-10 flex items-center"
        >
          {{ item.label }}
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from '@/components/ui/separator'

import { useUserInfoStore } from '~/stores/storeUserInfo'
import { useAuthStore } from '~/stores/storeAuth'
import { useAuthHandler } from '~/composables/useAuthHandler'
import avatar from "@/assets/icons/header/avatar.svg";

const userInfoStore = useUserInfoStore()
const authStore = useAuthStore()
const { handleManualSignOut } = useAuthHandler()
const userInfo = ref(userInfoStore.getUserInfo())
const isOpen = ref(false)

watch(() => userInfoStore.userInfo, () => { 
  userInfo.value = userInfoStore.getUserInfo();
})

const handleManageAccount = () => {
  isOpen.value = false;
  navigateTo('/account');
}

const handleReserveInstances = () => {
  isOpen.value = false;
  navigateTo('/home');
  // 這裡可以加入 Reserve Instances 的導航邏輯
}

const handleSignOut = async () => {
  isOpen.value = false;
  await handleManualSignOut();
}

const menuItems = [
  {
    id: 'manage-account',
    label: 'Manage Your Account',
    handler: handleManageAccount
  },
  {
    id: 'reserve-instances',
    label: 'Reserve Instances',
    handler: handleReserveInstances
  },
  {
    id: 'sign-out',
    label: 'Sign Out',
    handler: handleSignOut
  }
]
</script>

<style scoped></style>
